/*
  NOTE: THIS IS A TEMPORARY SOLUTION TO ALLOW FOLLOWING ON THE PROFILE PAGE
  UNTIL WE ARE ABLE TO IMPLEMENT THE NEW PROFILE EXPERIENCE. USING THIS COMPONENT WILL
  REQUIRE RUNNING THE APPLICATION WITH SSL IN DEVELOPMENT.
*/

import classNames from 'classnames';
import { UserConnection, UserConnectionActionType } from '@alltrails/shared/types/belay';
import { RequestState } from '@alltrails/shared/types/blazes';
import Button from '@alltrails/shared/denali/components/Button';
import { IdKey } from '@alltrails/shared/types/lists';
import onUserActionClick from 'utils/community/userAction';
import useFormatMessage from '@alltrails/shared/hooks/useFormatMessage';
import COMMUNITY_CONNECT from '../communityConnectStrings.string';
import * as styles from './styles/styles.module.scss';

type Props = {
  userConnection?: UserConnection;
  takeUserAction: (userActionKey: UserConnectionActionType) => void;
  className?: string;
  userId: IdKey;
};

const BlockButton = ({ userConnection, takeUserAction, className, userId }: Props): JSX.Element => {
  const {
    formattedDefaultMessages: { BLOCK, UNBLOCK, BLOCKING, UNBLOCKING }
  } = useFormatMessage(COMMUNITY_CONNECT);

  if (!userConnection || !userConnection.actions) {
    return <></>;
  }

  const { block, unblock } = userConnection.actions;
  const title = block ? BLOCK : UNBLOCK;
  const { requestState } = block || unblock || {};
  const loading = requestState === RequestState.Loading;
  const props = { disabled: loading, className: classNames(styles.button, className), testId: title };

  if (block) {
    return (
      <Button
        text={loading ? `${BLOCKING}...` : title}
        {...props}
        onClick={() => onUserActionClick(UserConnectionActionType.Block, userId, userConnection.user.id, takeUserAction)}
        size="sm"
        variant="flat"
      />
    );
  }

  if (unblock) {
    return (
      <Button
        text={loading ? `${UNBLOCKING}...` : title}
        {...props}
        onClick={() => onUserActionClick(UserConnectionActionType.Unblock, userId, userConnection.user.id, takeUserAction)}
        size="sm"
        variant="flat"
      />
    );
  }

  return <></>;
};

export default BlockButton;
